import { RadioGroup as RadioGroupHeadlessui} from '@headlessui/react'

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export const RadioGroup = ({input, options, value, onChange}) => {
    const inputValue = input ? input.value : value

    return <RadioGroupHeadlessui by="value" value={inputValue} onChange={(value)=> {
        onChange(value);
        if(input){
            input.onChange(value)
        }
    }} className="mt-2" >
        <div className={`grid grid-cols-${options.length} gap-${options.length} sm:grid-cols-${options.length}`}>
            {options.map((option) => (
                <RadioGroupHeadlessui.Option
                    key={option.name}
                    value={option}
                    className={({ active, checked }) => classNames(
                            !option.disabled ? 'cursor-pointer focus:outline-none' : 'cursor-not-allowed opacity-25',
                            active ? 'ring-2 ring-orange-600 ring-offset-2' : '',
                            checked
                                ? 'bg-orange-600 text-white hover:bg-orange-500'
                                : 'ring-1 ring-inset ring-gray-300 bg-white text-gray-900 hover:bg-gray-50',
                            'flex items-center justify-center rounded-md py-3 px-3 text-sm font-semibold uppercase sm:flex-1'
                        )
                    }
                    disabled={option.disabled}
                >
                    <RadioGroupHeadlessui.Label as="span">{option.name}</RadioGroupHeadlessui.Label>
                </RadioGroupHeadlessui.Option>
            ))}
        </div>
    </RadioGroupHeadlessui>
}